
/**
 * Encore Foundation - 2.23.0
 * 
 * The contents of this file is owned and generated by the Global Design Systems team.
 * If you require making changes to the values stored here please reach out
 * to #encore on Slack.
 * 
 * Links:
 * 
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 * 
 * Tack!
 * 
 * Global Design Systems
 * encore.spotify.net
 */

/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Aquamarine 180
*/
var aquamarine = exports.aquamarine = '#9bf0e1';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Aubergine 46
*/
var aubergine = exports.aubergine = '#503750';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Azure 135
*/
var azure = exports.azure = '#509bf5';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Bole 123
*/
var bole = exports.bole = '#c87d55';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Bright Red 100
*/
var brightRed = exports.brightRed = '#e61e32';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Chocolate 75
*/
var chocolate = exports.chocolate = '#7d4b32';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Citric 186
*/
var citric = exports.citric = '#cdf564';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Electric Seafoam 167
*/
var electricSeafoam = exports.electricSeafoam = '#19e68c';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Factory Yellow 184
*/
var factoryYellow = exports.factoryYellow = '#fae62d';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Forest 75
*/
var forest = exports.forest = '#006450';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Pink 100
*/
var fuchsia = exports.fuchsia = '#dc148c';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Gold 155
*/
var gold = exports.gold = '#f59b23';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Klein Blue 61
*/
var kleinBlue = exports.kleinBlue = '#4100f5';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Lavender 135
*/
var lavender = exports.lavender = '#b49bc8';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Maroon 55
*/
var maroon = exports.maroon = '#8c1932';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Midnight 35
*/
var midnight = exports.midnight = '#1e3264';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Neon Green 176
*/
var neonGreen = exports.neonGreen = '#5ff550';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Pumpkin 135
*/
var orange = exports.orange = '#ff6437';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Rose 180
*/
var pink = exports.pink = '#ffcdd2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Violet Desat 75
*/
var plum = exports.plum = '#705378';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Powder Green 185
*/
var powderGreen = exports.powderGreen = '#c3f0c8';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Royal Blue 55
*/
var royalBlue = exports.royalBlue = '#2d46b9';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Salmon 135
*/
var salmon = exports.salmon = '#f573a0';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Green Blue 100
*/
var spearmint = exports.spearmint = '#27856a';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Storm 155
*/
var storm = exports.storm = '#a0c3d2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Sunflower 172
*/
var sunflower = exports.sunflower = '#ffc864';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Tan 135
*/
var tan = exports.tan = '#c39687';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Red Orange 100
*/
var tangerine = exports.tangerine = '#e3230e';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Violet 84
*/
var violet = exports.violet = '#af2896';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, you can achieve similar results with the `bright accent` or `positive` colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var success = exports.success = '#1db954';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, you can achieve similar results by using the `announcement` colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var announcement = exports.announcement = '#2e77d0';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, you can achieve similar results with the `background elevated` colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var info = exports.info = '#eeeeee';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, you can achieve similar results with the `warning` colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var warning = exports.warning = '#ff5722';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, you can achieve similar results with the `negative` colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var failure = exports.failure = '#e22134';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var gray7 = exports.gray7 = '#121212';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var gray10 = exports.gray10 = '#181818';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var gray15 = exports.gray15 = '#282828';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var gray20 = exports.gray20 = '#333333';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var gray30 = exports.gray30 = '#535353';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var gray50 = exports.gray50 = '#7f7f7f';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var gray70 = exports.gray70 = '#b3b3b3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var gray80 = exports.gray80 = '#cccccc';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var gray85 = exports.gray85 = '#d9d9d9';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var gray90 = exports.gray90 = '#eeeeee';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var gray95 = exports.gray95 = '#f8f8f8';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to either `gray20` or `gray30`
*/
var gray25 = exports.gray25 = '#404040';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var opacityBlack0 = exports.opacityBlack0 = 'rgba(0, 0, 0, 0)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var opacityBlack10 = exports.opacityBlack10 = 'rgba(0, 0, 0, 0.1)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var opacityBlack30 = exports.opacityBlack30 = 'rgba(0, 0, 0, 0.3)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var opacityBlack50 = exports.opacityBlack50 = 'rgba(0, 0, 0, 0.5)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var opacityBlack60 = exports.opacityBlack60 = 'rgba(0, 0, 0, 0.6)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var opacityBlack70 = exports.opacityBlack70 = 'rgba(0, 0, 0, 0.7)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var opacityBlack90 = exports.opacityBlack90 = 'rgba(0, 0, 0, 0.9)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var opacityWhite0 = exports.opacityWhite0 = 'rgba(255, 255, 255, 0)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var opacityWhite10 = exports.opacityWhite10 = 'rgba(255, 255, 255, 0.1)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var opacityWhite30 = exports.opacityWhite30 = 'rgba(255, 255, 255, 0.3)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var opacityWhite50 = exports.opacityWhite50 = 'rgba(255, 255, 255, 0.5)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var opacityWhite60 = exports.opacityWhite60 = 'rgba(255, 255, 255, 0.6)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var opacityWhite70 = exports.opacityWhite70 = 'rgba(255, 255, 255, 0.7)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var opacityWhite90 = exports.opacityWhite90 = 'rgba(255, 255, 255, 0.9)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityBlack0`
*/
var black0 = exports.black0 = 'rgba(0, 0, 0, 0)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityBlack10`
*/
var black10 = exports.black10 = 'rgba(0, 0, 0, 0.1)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityBlack30`
*/
var black30 = exports.black30 = 'rgba(0, 0, 0, 0.3)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityBlack50`
*/
var black50 = exports.black50 = 'rgba(0, 0, 0, 0.5)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityBlack60`
*/
var black60 = exports.black60 = 'rgba(0, 0, 0, 0.6)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityBlack70`
*/
var black70 = exports.black70 = 'rgba(0, 0, 0, 0.7)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityBlack90`
*/
var black90 = exports.black90 = 'rgba(0, 0, 0, 0.9)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite0`
*/
var white0 = exports.white0 = 'rgba(255, 255, 255, 0)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite10`
*/
var white10 = exports.white10 = 'rgba(255, 255, 255, 0.1)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite30`
*/
var white30 = exports.white30 = 'rgba(255, 255, 255, 0.3)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite50`
*/
var white50 = exports.white50 = 'rgba(255, 255, 255, 0.5)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite60`
*/
var white60 = exports.white60 = 'rgba(255, 255, 255, 0.6)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite70`
*/
var white70 = exports.white70 = 'rgba(255, 255, 255, 0.7)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite90`
*/
var white90 = exports.white90 = 'rgba(255, 255, 255, 0.9)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to either `opacityBlack10` or `opacityBlack30`
*/
var black20 = exports.black20 = 'rgba(0, 0, 0, 0.2)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to either `opacityBlack30` or `opacityBlack50`
*/
var black40 = exports.black40 = 'rgba(0, 0, 0, 0.4)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite10`
*/
var white5 = exports.white5 = 'rgba(255, 255, 255, 0.05)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to either `opacityWhite10` or `opacityWhite30`
*/
var white20 = exports.white20 = 'rgba(255, 255, 255, 0.2)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to either `opacityWhite30` or `opacityWhite50`
*/
var white40 = exports.white40 = 'rgba(255, 255, 255, 0.4)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var green = exports.green = '#1db954';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var greenLight = exports.greenLight = '#1ed760';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var greenFocus = exports.greenFocus = '#1da64d';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var greenDark = exports.greenDark = '#14833b';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var black = exports.black = '#000000';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var white = exports.white = '#ffffff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the negative colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var red = exports.red = '#cd1a2b';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the negative colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var redLight = exports.redLight = '#e22134';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the negative colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var redDark = exports.redDark = '#941320';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the announcement colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var blue = exports.blue = '#2e77d0';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the announcement colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var blueLight = exports.blueLight = '#4687d6';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueFacebook = exports.blueFacebook = '#1877f2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the announcement colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var blueDark = exports.blueDark = '#1d4c85';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the warning colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
var orangeLight = exports.orangeLight = '#ff5722';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var solidBlack0 = exports.solidBlack0 = '#000000';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var solidWhite200 = exports.solidWhite200 = '#ffffff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spotifyBlack7 = exports.spotifyBlack7 = '#121212';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var midnight35 = exports.midnight35 = '#202F72';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var aubergine46 = exports.aubergine46 = '#503659';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var maroon55 = exports.maroon55 = '#8A202B';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var royalBlue55 = exports.royalBlue55 = '#283EA3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var kleinBlue61 = exports.kleinBlue61 = '#4100F4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forest75 = exports.forest75 = '#056952';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var chocolate75 = exports.chocolate75 = '#834F34';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violet84 = exports.violet84 = '#B02897';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brightRed100 = exports.brightRed100 = '#E91429';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spearmint114 = exports.spearmint114 = '#4B917D';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var fuchsia115 = exports.fuchsia115 = '#F036A4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var tangerine120 = exports.tangerine120 = '#FF4834';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bole123 = exports.bole123 = '#C87D55';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var salmon135 = exports.salmon135 = '#EF77A1';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var lavender135 = exports.lavender135 = '#AF93C4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var azure135 = exports.azure135 = '#59A0F6';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pumpkin135 = exports.pumpkin135 = '#FF7439';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var tan135 = exports.tan135 = '#C19384';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var storm155 = exports.storm155 = '#A5BBD1';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var gold155 = exports.gold155 = '#FFA42B';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spotifyGreen157 = exports.spotifyGreen157 = '#1ED760';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var sunflower172 = exports.sunflower172 = '#FFC862';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var rose180 = exports.rose180 = '#FFD2D7';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var aquamarine180 = exports.aquamarine180 = '#91EEDA';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var factoryYellow184 = exports.factoryYellow184 = '#FCE54F';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var powderGreen185 = exports.powderGreen185 = '#C5F0C9';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var citric186 = exports.citric186 = '#CFF56A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var neonGreen176 = exports.neonGreen176 = '#5FF550';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var electricSeafoam167 = exports.electricSeafoam167 = '#19E68C';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redOrange25 = exports.redOrange25 = '#560F00';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redOrange55 = exports.redOrange55 = '#911600';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redOrange75 = exports.redOrange75 = '#B71800';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redOrange100 = exports.redOrange100 = '#E81B00';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redOrange120 = exports.redOrange120 = '#FF4834';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redOrange135 = exports.redOrange135 = '#FF7163';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redOrange155 = exports.redOrange155 = '#FF9E95';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redOrange180 = exports.redOrange180 = '#FFD3CF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brown25 = exports.brown25 = '#3D2418';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brown55 = exports.brown55 = '#683E2A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brown75 = exports.brown75 = '#834F34';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brown100 = exports.brown100 = '#A96440';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brown123 = exports.brown123 = '#C87D55';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brown135 = exports.brown135 = '#D38E67';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brown155 = exports.brown155 = '#E5AC8A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brown180 = exports.brown180 = '#F7D7C3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownDesat25 = exports.brownDesat25 = '#3B251D';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownDesat55 = exports.brownDesat55 = '#653F32';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownDesat75 = exports.brownDesat75 = '#805040';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownDesat100 = exports.brownDesat100 = '#A36652';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownDesat135 = exports.brownDesat135 = '#C19384';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownDesat155 = exports.brownDesat155 = '#D2B1A6';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownDesat180 = exports.brownDesat180 = '#EADAD5';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var orange25 = exports.orange25 = '#4F1800';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var orange55 = exports.orange55 = '#862800';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var orange75 = exports.orange75 = '#A83200';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var orange100 = exports.orange100 = '#D64000';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var orange135 = exports.orange135 = '#FF7439';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var orange155 = exports.orange155 = '#FFA178';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var orange180 = exports.orange180 = '#FFD4C2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellow25 = exports.brownYellow25 = '#491E00';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellow55 = exports.brownYellow55 = '#793500';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellow75 = exports.brownYellow75 = '#964400';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellow100 = exports.brownYellow100 = '#BC5900';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellow135 = exports.brownYellow135 = '#F47E00';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellow155 = exports.brownYellow155 = '#FFA42B';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellow172 = exports.brownYellow172 = '#FFC862';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellow180 = exports.brownYellow180 = '#FFD97E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellowDesat25 = exports.brownYellowDesat25 = '#39260E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellowDesat55 = exports.brownYellowDesat55 = '#624218';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellowDesat75 = exports.brownYellowDesat75 = '#7C531E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellowDesat100 = exports.brownYellowDesat100 = '#9F6B27';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellowDesat135 = exports.brownYellowDesat135 = '#D0913F';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellowDesat155 = exports.brownYellowDesat155 = '#DEB076';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brownYellowDesat180 = exports.brownYellowDesat180 = '#EFDABF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellow25 = exports.yellow25 = '#352901';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellow55 = exports.yellow55 = '#594602';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellow75 = exports.yellow75 = '#705903';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellow100 = exports.yellow100 = '#8E7203';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellow135 = exports.yellow135 = '#BD9A03';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellow155 = exports.yellow155 = '#DAB503';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellow184 = exports.yellow184 = '#FCE54F';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellowGreen25 = exports.yellowGreen25 = '#222E03';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellowGreen55 = exports.yellowGreen55 = '#3B4F05';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellowGreen75 = exports.yellowGreen75 = '#4A6406';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellowGreen100 = exports.yellowGreen100 = '#5F8008';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellowGreen135 = exports.yellowGreen135 = '#80AC0B';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellowGreen155 = exports.yellowGreen155 = '#95C90D';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellowGreen186 = exports.yellowGreen186 = '#CFF56A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellowGreenDesat25 = exports.yellowGreenDesat25 = '#262D11';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellowGreenDesat55 = exports.yellowGreenDesat55 = '#414D1E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellowGreenDesat75 = exports.yellowGreenDesat75 = '#526226';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellowGreenDesat100 = exports.yellowGreenDesat100 = '#697D30';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellowGreenDesat135 = exports.yellowGreenDesat135 = '#8DA841';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellowGreenDesat155 = exports.yellowGreenDesat155 = '#A9C261';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var yellowGreenDesat180 = exports.yellowGreenDesat180 = '#D7E3B5';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var green25 = exports.green25 = '#073116';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var green55 = exports.green55 = '#0C5426';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var green75 = exports.green75 = '#0F6A2F';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var green100 = exports.green100 = '#13873C';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var green135 = exports.green135 = '#19B551';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var green157 = exports.green157 = '#1ED760';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var green180 = exports.green180 = '#96F0B6';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenDesat25 = exports.greenDesat25 = '#182F21';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenDesat55 = exports.greenDesat55 = '#265135';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenDesat75 = exports.greenDesat75 = '#2D6740';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenDesat100 = exports.greenDesat100 = '#34854D';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenDesat135 = exports.greenDesat135 = '#3DB35E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenDesat155 = exports.greenDesat155 = '#5CCE77';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenDesat185 = exports.greenDesat185 = '#C5F0C9';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlue25 = exports.greenBlue25 = '#013126';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlue55 = exports.greenBlue55 = '#035341';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlue75 = exports.greenBlue75 = '#056952';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlue100 = exports.greenBlue100 = '#088569';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlue135 = exports.greenBlue135 = '#10B28E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlue155 = exports.greenBlue155 = '#16D0A6';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlue180 = exports.greenBlue180 = '#91EEDA';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlueDesat25 = exports.greenBlueDesat25 = '#182E28';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlueDesat55 = exports.greenBlueDesat55 = '#294F44';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlueDesat75 = exports.greenBlueDesat75 = '#346557';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlueDesat100 = exports.greenBlueDesat100 = '#43816F';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlueDesat114 = exports.greenBlueDesat114 = '#4B917D';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlueDesat135 = exports.greenBlueDesat135 = '#5EAC96';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlueDesat155 = exports.greenBlueDesat155 = '#8BC3B3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var greenBlueDesat180 = exports.greenBlueDesat180 = '#C9E3DB';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blue25 = exports.blue25 = '#052A56';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blue55 = exports.blue55 = '#084791';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blue75 = exports.blue75 = '#0A59B8';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blue100 = exports.blue100 = '#0D72EA';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blue135 = exports.blue135 = '#59A0F6';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blue155 = exports.blue155 = '#89BCF8';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blue180 = exports.blue180 = '#C8E0FC';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueDesat25 = exports.blueDesat25 = '#1D2B3A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueDesat55 = exports.blueDesat55 = '#324B64';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueDesat75 = exports.blueDesat75 = '#405E7E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueDesat100 = exports.blueDesat100 = '#5179A1';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueDesat135 = exports.blueDesat135 = '#82A1C0';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueDesat155 = exports.blueDesat155 = '#A5BBD1';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueDesat180 = exports.blueDesat180 = '#D4DFE9';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueViolet25 = exports.blueViolet25 = '#26008D';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueViolet55 = exports.blueViolet55 = '#3C00E4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueViolet61 = exports.blueViolet61 = '#4100F4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueViolet75 = exports.blueViolet75 = '#5925FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueViolet100 = exports.blueViolet100 = '#7358FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueViolet135 = exports.blueViolet135 = '#9691FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueViolet155 = exports.blueViolet155 = '#AFB1FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueViolet180 = exports.blueViolet180 = '#D7DBFF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueVioletDesat25 = exports.blueVioletDesat25 = '#1B2658';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueVioletDesat35 = exports.blueVioletDesat35 = '#202F72';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueVioletDesat55 = exports.blueVioletDesat55 = '#283EA3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueVioletDesat75 = exports.blueVioletDesat75 = '#334FCD';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueVioletDesat100 = exports.blueVioletDesat100 = '#576DD6';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueVioletDesat135 = exports.blueVioletDesat135 = '#8A9AE3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueVioletDesat155 = exports.blueVioletDesat155 = '#AAB6EA';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var blueVioletDesat180 = exports.blueVioletDesat180 = '#D7DCF5';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violet25 = exports.violet25 = '#400073';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violet55 = exports.violet55 = '#6900BA';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violet75 = exports.violet75 = '#8400E7';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violet100 = exports.violet100 = '#A833FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violet135 = exports.violet135 = '#C87DFF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violet155 = exports.violet155 = '#D8A3FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violet180 = exports.violet180 = '#EDD4FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetDesat25 = exports.violetDesat25 = '#35243A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetDesat46 = exports.violetDesat46 = '#503659';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetDesat75 = exports.violetDesat75 = '#734D85';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetDesat100 = exports.violetDesat100 = '#8E65A9';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetDesat135 = exports.violetDesat135 = '#AF93C4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetDesat155 = exports.violetDesat155 = '#C4B1D4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetDesat180 = exports.violetDesat180 = '#E3DAEB';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPink25 = exports.violetPink25 = '#4C1141';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPink55 = exports.violetPink55 = '#801D6D';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPink75 = exports.violetPink75 = '#A1258A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPink84 = exports.violetPink84 = '#B02897';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPink100 = exports.violetPink100 = '#CC2FAF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPink135 = exports.violetPink135 = '#E079CD';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPink155 = exports.violetPink155 = '#E9A1DC';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPink180 = exports.violetPink180 = '#F5D3EF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPinkDesat25 = exports.violetPinkDesat25 = '#3C1C4C';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPinkDesat55 = exports.violetPinkDesat55 = '#673081';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPinkDesat67 = exports.violetPinkDesat67 = '#773796';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPinkDesat100 = exports.violetPinkDesat100 = '#9E57BF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPinkDesat135 = exports.violetPinkDesat135 = '#BB8DD0';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPinkDesat155 = exports.violetPinkDesat155 = '#CDADDC';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var violetPinkDesat180 = exports.violetPinkDesat180 = '#E7D9ED';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pink25 = exports.pink25 = '#550635';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pink55 = exports.pink55 = '#8D0B58';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pink75 = exports.pink75 = '#B00D6E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pink100 = exports.pink100 = '#DF118B';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pink115 = exports.pink115 = '#F036A4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pink135 = exports.pink135 = '#F46EBE';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pink155 = exports.pink155 = '#F79BD2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pink180 = exports.pink180 = '#FCD2EB';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pinkDesat25 = exports.pinkDesat25 = '#4C172A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pinkDesat55 = exports.pinkDesat55 = '#871F43';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pinkDesat75 = exports.pinkDesat75 = '#AD2152';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pinkDesat100 = exports.pinkDesat100 = '#DE2666';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pinkDesat135 = exports.pinkDesat135 = '#EF77A1';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pinkDesat155 = exports.pinkDesat155 = '#F1A2BC';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var pinkDesat180 = exports.pinkDesat180 = '#F4D6DF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var red25 = exports.red25 = '#590810';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var red55 = exports.red55 = '#930D1A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var red75 = exports.red75 = '#B81021';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var red100 = exports.red100 = '#E91429';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var red135 = exports.red135 = '#F97481';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var red155 = exports.red155 = '#FE9DA7';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var red180 = exports.red180 = '#FFD2D7';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redDesat25 = exports.redDesat25 = '#521319';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redDesat55 = exports.redDesat55 = '#8A202B';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redDesat75 = exports.redDesat75 = '#AD2836';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redDesat100 = exports.redDesat100 = '#D33F4E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redDesat135 = exports.redDesat135 = '#E2828C';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redDesat155 = exports.redDesat155 = '#EAA6AD';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var redDesat180 = exports.redDesat180 = '#F5D6D9';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var fluorescentRed109 = exports.fluorescentRed109 = '#FF001A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var fluorescentOrange144 = exports.fluorescentOrange144 = '#FF8B1F';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var fluorescentYellow194 = exports.fluorescentYellow194 = '#F3FF46';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var fluorescentGreen176 = exports.fluorescentGreen176 = '#5FF550';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var fluorescentGreenBlue167 = exports.fluorescentGreenBlue167 = '#19E68C';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var fluorescentCyan185 = exports.fluorescentCyan185 = '#00FFFF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var fluorescentBlueViolet69 = exports.fluorescentBlueViolet69 = '#2D28FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var fluorescentViolet111 = exports.fluorescentViolet111 = '#C13FFF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var fluorescentPink119 = exports.fluorescentPink119 = '#FF1ABF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiArabicBlackOtf = exports.circularSpotifyUiArabicBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Black.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiArabicBlackWoff = exports.circularSpotifyUiArabicBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Black.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiArabicBlackWoff2 = exports.circularSpotifyUiArabicBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Black.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiArabicBoldOtf = exports.circularSpotifyUiArabicBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Bold.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiArabicBoldWoff = exports.circularSpotifyUiArabicBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Bold.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiArabicBoldWoff2 = exports.circularSpotifyUiArabicBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Bold.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiArabicBookOtf = exports.circularSpotifyUiArabicBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Book.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiArabicBookWoff = exports.circularSpotifyUiArabicBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Book.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiArabicBookWoff2 = exports.circularSpotifyUiArabicBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Book.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiArabicLightOtf = exports.circularSpotifyUiArabicLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Light.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiArabicLightWoff = exports.circularSpotifyUiArabicLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Light.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiArabicLightWoff2 = exports.circularSpotifyUiArabicLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Light.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiArabicMediumOtf = exports.circularSpotifyUiArabicMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Medium.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiArabicMediumWoff = exports.circularSpotifyUiArabicMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Medium.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiArabicMediumWoff2 = exports.circularSpotifyUiArabicMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Medium.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiCyrillicBlackOtf = exports.circularSpotifyUiCyrillicBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Black.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiCyrillicBlackWoff = exports.circularSpotifyUiCyrillicBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Black.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiCyrillicBlackWoff2 = exports.circularSpotifyUiCyrillicBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Black.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiCyrillicBoldOtf = exports.circularSpotifyUiCyrillicBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Bold.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiCyrillicBoldWoff = exports.circularSpotifyUiCyrillicBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Bold.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiCyrillicBoldWoff2 = exports.circularSpotifyUiCyrillicBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Bold.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiCyrillicBookOtf = exports.circularSpotifyUiCyrillicBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Book.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiCyrillicBookWoff = exports.circularSpotifyUiCyrillicBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Book.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiCyrillicBookWoff2 = exports.circularSpotifyUiCyrillicBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Book.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiCyrillicLightOtf = exports.circularSpotifyUiCyrillicLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Light.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiCyrillicLightWoff = exports.circularSpotifyUiCyrillicLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Light.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiCyrillicLightWoff2 = exports.circularSpotifyUiCyrillicLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Light.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiCyrillicMediumOtf = exports.circularSpotifyUiCyrillicMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Medium.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiCyrillicMediumWoff = exports.circularSpotifyUiCyrillicMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Medium.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiCyrillicMediumWoff2 = exports.circularSpotifyUiCyrillicMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Medium.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiHebrewBlackOtf = exports.circularSpotifyUiHebrewBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Black.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiHebrewBlackWoff = exports.circularSpotifyUiHebrewBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Black.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiHebrewBlackWoff2 = exports.circularSpotifyUiHebrewBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Black.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiHebrewBoldOtf = exports.circularSpotifyUiHebrewBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Bold.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiHebrewBoldWoff = exports.circularSpotifyUiHebrewBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Bold.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiHebrewBoldWoff2 = exports.circularSpotifyUiHebrewBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Bold.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiHebrewBookOtf = exports.circularSpotifyUiHebrewBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Book.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiHebrewBookWoff = exports.circularSpotifyUiHebrewBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Book.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiHebrewBookWoff2 = exports.circularSpotifyUiHebrewBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Book.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiHebrewLightOtf = exports.circularSpotifyUiHebrewLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Light.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiHebrewLightWoff = exports.circularSpotifyUiHebrewLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Light.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiHebrewLightWoff2 = exports.circularSpotifyUiHebrewLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Light.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiHebrewMediumOtf = exports.circularSpotifyUiHebrewMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Medium.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiHebrewMediumWoff = exports.circularSpotifyUiHebrewMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Medium.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiHebrewMediumWoff2 = exports.circularSpotifyUiHebrewMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Medium.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiLatinBlackOtf = exports.circularSpotifyUiLatinBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Black.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinBlackWoff = exports.circularSpotifyUiLatinBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Black.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinBlackWoff2 = exports.circularSpotifyUiLatinBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Black.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiLatinBoldOtf = exports.circularSpotifyUiLatinBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Bold.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinBoldWoff = exports.circularSpotifyUiLatinBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Bold.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinBoldWoff2 = exports.circularSpotifyUiLatinBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Bold.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiLatinBookOtf = exports.circularSpotifyUiLatinBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Book.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinBookWoff = exports.circularSpotifyUiLatinBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Book.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinBookWoff2 = exports.circularSpotifyUiLatinBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Book.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinLightOtf = exports.circularSpotifyUiLatinLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Light.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinLightWoff = exports.circularSpotifyUiLatinLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Light.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinLightWoff2 = exports.circularSpotifyUiLatinLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Light.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinMediumOtf = exports.circularSpotifyUiLatinMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Medium.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinMediumWoff = exports.circularSpotifyUiLatinMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Medium.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinMediumWoff2 = exports.circularSpotifyUiLatinMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Medium.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinOs2V3BlackOtf = exports.circularSpotifyUiLatinOs2V3BlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Black.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiLatinOs2V3BlackWoff = exports.circularSpotifyUiLatinOs2V3BlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Black.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiLatinOs2V3BlackWoff2 = exports.circularSpotifyUiLatinOs2V3BlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Black.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiLatinOs2V3BoldOtf = exports.circularSpotifyUiLatinOs2V3BoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Bold.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiLatinOs2V3BoldWoff = exports.circularSpotifyUiLatinOs2V3BoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Bold.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiLatinOs2V3BoldWoff2 = exports.circularSpotifyUiLatinOs2V3BoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Bold.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiLatinOs2V3BookOtf = exports.circularSpotifyUiLatinOs2V3BookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Book.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiLatinOs2V3BookWoff = exports.circularSpotifyUiLatinOs2V3BookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Book.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var circularSpotifyUiLatinOs2V3BookWoff2 = exports.circularSpotifyUiLatinOs2V3BookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Book.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinOs2V3LightOtf = exports.circularSpotifyUiLatinOs2V3LightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Light.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinOs2V3LightWoff = exports.circularSpotifyUiLatinOs2V3LightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Light.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinOs2V3LightWoff2 = exports.circularSpotifyUiLatinOs2V3LightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Light.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinOs2V3MediumOtf = exports.circularSpotifyUiLatinOs2V3MediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Medium.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinOs2V3MediumWoff = exports.circularSpotifyUiLatinOs2V3MediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Medium.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularSpotifyUiLatinOs2V3MediumWoff2 = exports.circularSpotifyUiLatinOs2V3MediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Medium.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularMonoLatinBookOtf = exports.circularMonoLatinBookOtf = 'https://encore.scdn.co/1.2.3/Circular-Mono-Latin-Book.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var circularMonoLatinBookWoff = exports.circularMonoLatinBookWoff = 'https://encore.scdn.co/1.2.3/Circular-Mono-Latin-Book.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyHangulBlackOtf = exports.sieulguilSpotifyHangulBlackOtf = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Black.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyHangulBlackWoff = exports.sieulguilSpotifyHangulBlackWoff = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Black.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyHangulBlackWoff2 = exports.sieulguilSpotifyHangulBlackWoff2 = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Black.woff2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyHangulBoldOtf = exports.sieulguilSpotifyHangulBoldOtf = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Bold.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyHangulBoldWoff = exports.sieulguilSpotifyHangulBoldWoff = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Bold.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyHangulBoldWoff2 = exports.sieulguilSpotifyHangulBoldWoff2 = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Bold.woff2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyHangulLightOtf = exports.sieulguilSpotifyHangulLightOtf = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Light.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyHangulLightWoff = exports.sieulguilSpotifyHangulLightWoff = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Light.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyHangulLightWoff2 = exports.sieulguilSpotifyHangulLightWoff2 = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Light.woff2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyHangulMediumOtf = exports.sieulguilSpotifyHangulMediumOtf = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Medium.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyHangulMediumWoff = exports.sieulguilSpotifyHangulMediumWoff = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Medium.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyHangulMediumWoff2 = exports.sieulguilSpotifyHangulMediumWoff2 = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Medium.woff2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyLatinHangulBlackOtf = exports.sieulguilSpotifyLatinHangulBlackOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Black.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyLatinHangulBlackWoff = exports.sieulguilSpotifyLatinHangulBlackWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Black.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyLatinHangulBlackWoff2 = exports.sieulguilSpotifyLatinHangulBlackWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Black.woff2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyLatinHangulBoldOtf = exports.sieulguilSpotifyLatinHangulBoldOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Bold.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyLatinHangulBoldWoff = exports.sieulguilSpotifyLatinHangulBoldWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Bold.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyLatinHangulBoldWoff2 = exports.sieulguilSpotifyLatinHangulBoldWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Bold.woff2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyLatinHangulLightOtf = exports.sieulguilSpotifyLatinHangulLightOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Light.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyLatinHangulLightWoff = exports.sieulguilSpotifyLatinHangulLightWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Light.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyLatinHangulLightWoff2 = exports.sieulguilSpotifyLatinHangulLightWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Light.woff2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyLatinHangulMediumOtf = exports.sieulguilSpotifyLatinHangulMediumOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Medium.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyLatinHangulMediumWoff = exports.sieulguilSpotifyLatinHangulMediumWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Medium.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
var sieulguilSpotifyLatinHangulMediumWoff2 = exports.sieulguilSpotifyLatinHangulMediumWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Medium.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
* 100% transparency of an element
*/
var opacity0 = exports.opacity0 = '0';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
* 90% transparency of an element
*/
var opacity10 = exports.opacity10 = '0.1';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
* 70% transparency of an element
*/
var opacity30 = exports.opacity30 = '0.3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
* 50% transparency of an element
*/
var opacity50 = exports.opacity50 = '0.5';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
* 30% transparency of an element
*/
var opacity70 = exports.opacity70 = '0.7';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
* 10% transparency of an element
*/
var opacity90 = exports.opacity90 = '0.9';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spacer4 = exports.spacer4 = '4px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spacer8 = exports.spacer8 = '8px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spacer12 = exports.spacer12 = '12px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spacer16 = exports.spacer16 = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spacer20 = exports.spacer20 = '20px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spacer24 = exports.spacer24 = '24px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spacer32 = exports.spacer32 = '32px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spacer40 = exports.spacer40 = '40px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spacer48 = exports.spacer48 = '48px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spacer56 = exports.spacer56 = '56px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spacer64 = exports.spacer64 = '64px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spacer72 = exports.spacer72 = '72px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var spacer80 = exports.spacer80 = '80px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladFontSize = exports.balladFontSize = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladA11YFontSizeMin = exports.balladA11YFontSizeMin = '13px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladA11YFontSizeMax = exports.balladA11YFontSizeMax = '22px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladA11YFontSizeAxMax = exports.balladA11YFontSizeAxMax = '50px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladLineHeight = exports.balladLineHeight = '24px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladA11YLineHeightMax = exports.balladA11YLineHeightMax = '30px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladA11YLineHeightAxMax = exports.balladA11YLineHeightAxMax = '58px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladWeight = exports.balladWeight = 400;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladFont = exports.balladFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladBoldFontSize = exports.balladBoldFontSize = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladBoldA11YFontSizeMin = exports.balladBoldA11YFontSizeMin = '13px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladBoldA11YFontSizeMax = exports.balladBoldA11YFontSizeMax = '22px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladBoldA11YFontSizeAxMax = exports.balladBoldA11YFontSizeAxMax = '50px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladBoldLineHeight = exports.balladBoldLineHeight = '24px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladBoldA11YLineHeightMax = exports.balladBoldA11YLineHeightMax = '30px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladBoldA11YLineHeightAxMax = exports.balladBoldA11YLineHeightAxMax = '58px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladBoldWeight = exports.balladBoldWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var balladBoldFont = exports.balladBoldFont = 'Circular';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaFontSize = exports.violaFontSize = '14px';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaA11YFontSizeMin = exports.violaA11YFontSizeMin = '11px';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaA11YFontSizeMax = exports.violaA11YFontSizeMax = '20px';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaA11YFontSizeAxMax = exports.violaA11YFontSizeAxMax = '48px';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaLineHeight = exports.violaLineHeight = '20px';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaA11YLineHeightMax = exports.violaA11YLineHeightMax = '26px';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaA11YLineHeightAxMax = exports.violaA11YLineHeightAxMax = '54px';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaWeight = exports.violaWeight = 400;
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaFont = exports.violaFont = 'Circular';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaBoldFontSize = exports.violaBoldFontSize = '14px';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaBoldA11YFontSizeMin = exports.violaBoldA11YFontSizeMin = '11px';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaBoldA11YFontSizeMax = exports.violaBoldA11YFontSizeMax = '20px';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaBoldA11YFontSizeAxMax = exports.violaBoldA11YFontSizeAxMax = '48px';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaBoldLineHeight = exports.violaBoldLineHeight = '20px';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaBoldA11YLineHeightMax = exports.violaBoldA11YLineHeightMax = '26px';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaBoldA11YLineHeightAxMax = exports.violaBoldA11YLineHeightAxMax = '54px';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaBoldWeight = exports.violaBoldWeight = 700;
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
var violaBoldFont = exports.violaBoldFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoFontSize = exports.mestoFontSize = '13px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoA11YFontSizeMin = exports.mestoA11YFontSizeMin = '10px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoA11YFontSizeMax = exports.mestoA11YFontSizeMax = '19px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoA11YFontSizeAxMax = exports.mestoA11YFontSizeAxMax = '46px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoLineHeight = exports.mestoLineHeight = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoA11YLineHeightMax = exports.mestoA11YLineHeightMax = '22px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoA11YLineHeightAxMax = exports.mestoA11YLineHeightAxMax = '49px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoWeight = exports.mestoWeight = 400;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoFont = exports.mestoFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoBoldFontSize = exports.mestoBoldFontSize = '13px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoBoldA11YFontSizeMin = exports.mestoBoldA11YFontSizeMin = '10px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoBoldA11YFontSizeMax = exports.mestoBoldA11YFontSizeMax = '19px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoBoldA11YFontSizeAxMax = exports.mestoBoldA11YFontSizeAxMax = '46px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoBoldLineHeight = exports.mestoBoldLineHeight = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoBoldA11YLineHeightMax = exports.mestoBoldA11YLineHeightMax = '22px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoBoldA11YLineHeightAxMax = exports.mestoBoldA11YLineHeightAxMax = '49px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoBoldWeight = exports.mestoBoldWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var mestoBoldFont = exports.mestoBoldFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassFontSize = exports.bassFontSize = '56px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassA11YFontSizeMin = exports.bassA11YFontSizeMin = '53px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassA11YFontSizeMax = exports.bassA11YFontSizeMax = '62px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassA11YFontSizeAxMax = exports.bassA11YFontSizeAxMax = '64px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassLineHeight = exports.bassLineHeight = '56px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassA11YLineHeightMax = exports.bassA11YLineHeightMax = '62px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassA11YLineHeightAxMax = exports.bassA11YLineHeightAxMax = '64px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassWeight = exports.bassWeight = 900;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassTracking = exports.bassTracking = '-0.04em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassFont = exports.bassFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassFontTracking = exports.bassFontTracking = 'CircularSpUIm40-Bold';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassMinimumScaleFactorMin = exports.bassMinimumScaleFactorMin = '0.25';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassMinimumScaleFactor = exports.bassMinimumScaleFactor = '0.3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassMinimumScaleFactorMax = exports.bassMinimumScaleFactorMax = '0.4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var bassMinimumScaleFactorAxMax = exports.bassMinimumScaleFactorAxMax = '0.8';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteFontSize = exports.forteFontSize = '48px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteA11YFontSizeMin = exports.forteA11YFontSizeMin = '45px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteA11YFontSizeMax = exports.forteA11YFontSizeMax = '54px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteA11YFontSizeAxMax = exports.forteA11YFontSizeAxMax = '62px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteLineHeight = exports.forteLineHeight = '48px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteA11YLineHeightMax = exports.forteA11YLineHeightMax = '54px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteA11YLineHeightAxMax = exports.forteA11YLineHeightAxMax = '62px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteWeight = exports.forteWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteTracking = exports.forteTracking = '-0.04em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteFont = exports.forteFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteFontTracking = exports.forteFontTracking = 'CircularSpUIm40-Bold';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteMinimumScaleFactorMin = exports.forteMinimumScaleFactorMin = '0.3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteMinimumScaleFactor = exports.forteMinimumScaleFactor = '0.35';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteMinimumScaleFactorMax = exports.forteMinimumScaleFactorMax = '0.45';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var forteMinimumScaleFactorAxMax = exports.forteMinimumScaleFactorAxMax = '0.85';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioFontSize = exports.brioFontSize = '40px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioA11YFontSizeMin = exports.brioA11YFontSizeMin = '37px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioA11YFontSizeMax = exports.brioA11YFontSizeMax = '46px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioA11YFontSizeAxMax = exports.brioA11YFontSizeAxMax = '60px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioLineHeight = exports.brioLineHeight = '40px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioA11YLineHeightMax = exports.brioA11YLineHeightMax = '46px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioA11YLineHeightAxMax = exports.brioA11YLineHeightAxMax = '60px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioWeight = exports.brioWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioTracking = exports.brioTracking = '-0.04em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioFont = exports.brioFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioFontTracking = exports.brioFontTracking = 'CircularSpUIm40-Bold';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioMinimumScaleFactorMin = exports.brioMinimumScaleFactorMin = '0.35';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioMinimumScaleFactor = exports.brioMinimumScaleFactor = '0.40';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioMinimumScaleFactorMax = exports.brioMinimumScaleFactorMax = '0.5';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var brioMinimumScaleFactorAxMax = exports.brioMinimumScaleFactorAxMax = '0.85';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleFontSize = exports.finaleFontSize = '11px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleA11YFontSizeMin = exports.finaleA11YFontSizeMin = '10px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleA11YFontSizeMax = exports.finaleA11YFontSizeMax = '17px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleA11YFontSizeAxMax = exports.finaleA11YFontSizeAxMax = '42px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleLineHeight = exports.finaleLineHeight = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleA11YLineHeightMax = exports.finaleA11YLineHeightMax = '22px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleA11YLineHeightAxMax = exports.finaleA11YLineHeightAxMax = '47px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleWeight = exports.finaleWeight = 400;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleFont = exports.finaleFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleBoldFontSize = exports.finaleBoldFontSize = '11px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleBoldA11YFontSizeMin = exports.finaleBoldA11YFontSizeMin = '10px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleBoldA11YFontSizeMax = exports.finaleBoldA11YFontSizeMax = '17px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleBoldA11YFontSizeAxMax = exports.finaleBoldA11YFontSizeAxMax = '42px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleBoldLineHeight = exports.finaleBoldLineHeight = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleBoldA11YLineHeightMax = exports.finaleBoldA11YLineHeightMax = '22px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleBoldA11YLineHeightAxMax = exports.finaleBoldA11YLineHeightAxMax = '47px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleBoldWeight = exports.finaleBoldWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var finaleBoldFont = exports.finaleBoldFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetFontSize = exports.minuetFontSize = '10px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetA11YFontSizeMin = exports.minuetA11YFontSizeMin = '10px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetA11YFontSizeMax = exports.minuetA11YFontSizeMax = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetA11YFontSizeAxMax = exports.minuetA11YFontSizeAxMax = '40px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetLineHeight = exports.minuetLineHeight = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetA11YLineHeightMax = exports.minuetA11YLineHeightMax = '22px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetA11YLineHeightAxMax = exports.minuetA11YLineHeightAxMax = '46px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetWeight = exports.minuetWeight = 400;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetTracking = exports.minuetTracking = '0.1em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetUppercase = exports.minuetUppercase = 'uppercase';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetFont = exports.minuetFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetFontTracking = exports.minuetFontTracking = 'CircularSpUIp100-Book';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetBoldFontSize = exports.minuetBoldFontSize = '10px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetBoldA11YFontSizeMin = exports.minuetBoldA11YFontSizeMin = '10px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetBoldA11YFontSizeMax = exports.minuetBoldA11YFontSizeMax = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetBoldA11YFontSizeAxMax = exports.minuetBoldA11YFontSizeAxMax = '40px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetBoldLineHeight = exports.minuetBoldLineHeight = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetBoldA11YLineHeightMax = exports.minuetBoldA11YLineHeightMax = '22px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetBoldA11YLineHeightAxMax = exports.minuetBoldA11YLineHeightAxMax = '46px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetBoldWeight = exports.minuetBoldWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetBoldTracking = exports.minuetBoldTracking = '0.1em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetBoldUppercase = exports.minuetBoldUppercase = 'uppercase';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetBoldFont = exports.minuetBoldFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var minuetBoldFontTracking = exports.minuetBoldFontTracking = 'CircularSpUIp100-Bold';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeFontSize = exports.metronomeFontSize = '14px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeA11YFontSizeMin = exports.metronomeA11YFontSizeMin = '11px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeA11YFontSizeMax = exports.metronomeA11YFontSizeMax = '20px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeA11YFontSizeAxMax = exports.metronomeA11YFontSizeAxMax = '48px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeLineHeight = exports.metronomeLineHeight = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeA11YLineHeightMax = exports.metronomeA11YLineHeightMax = '22px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeA11YLineHeightAxMax = exports.metronomeA11YLineHeightAxMax = '50px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeWeight = exports.metronomeWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeTracking = exports.metronomeTracking = '0.1em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeA11YTrackingMin = exports.metronomeA11YTrackingMin = '0.1em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeA11YTrackingMax = exports.metronomeA11YTrackingMax = '0.1em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeA11YTrackingAxMax = exports.metronomeA11YTrackingAxMax = '20';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeUppercase = exports.metronomeUppercase = 'uppercase';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeFont = exports.metronomeFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var metronomeFontTracking = exports.metronomeFontTracking = 'CircularSpUIp100-Bold';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoBrioFontSize = exports.altoBrioFontSize = '32px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoBrioA11YFontSizeMin = exports.altoBrioA11YFontSizeMin = '29px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoBrioA11YFontSizeMax = exports.altoBrioA11YFontSizeMax = '38px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoBrioA11YFontSizeAxMax = exports.altoBrioA11YFontSizeAxMax = '58px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoBrioLineHeight = exports.altoBrioLineHeight = '36px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoBrioA11YLineHeightMax = exports.altoBrioA11YLineHeightMax = '42px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoBrioA11YLineHeightAxMax = exports.altoBrioA11YLineHeightAxMax = '62px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoBrioWeight = exports.altoBrioWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoBrioTracking = exports.altoBrioTracking = '-0.04em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoBrioFont = exports.altoBrioFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoBrioFontTracking = exports.altoBrioFontTracking = 'CircularSpUIm40-Bold';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoFontSize = exports.altoFontSize = '32px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoA11YFontSizeMin = exports.altoA11YFontSizeMin = '29px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoA11YFontSizeMax = exports.altoA11YFontSizeMax = '38px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoA11YFontSizeAxMax = exports.altoA11YFontSizeAxMax = '58px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoLineHeight = exports.altoLineHeight = '36px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoA11YLineHeightMax = exports.altoA11YLineHeightMax = '42px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoA11YLineHeightAxMax = exports.altoA11YLineHeightAxMax = '62px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoWeight = exports.altoWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoTracking = exports.altoTracking = '-0.04em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoFont = exports.altoFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var altoFontTracking = exports.altoFontTracking = 'CircularSpUIm40-Bold';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var canonFontSize = exports.canonFontSize = '24px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var canonA11YFontSizeMin = exports.canonA11YFontSizeMin = '21px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var canonA11YFontSizeMax = exports.canonA11YFontSizeMax = '30px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var canonA11YFontSizeAxMax = exports.canonA11YFontSizeAxMax = '56px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var canonLineHeight = exports.canonLineHeight = '28px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var canonA11YLineHeightMax = exports.canonA11YLineHeightMax = '34px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var canonA11YLineHeightAxMax = exports.canonA11YLineHeightAxMax = '60px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var canonWeight = exports.canonWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var canonTracking = exports.canonTracking = '-0.04em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var canonFont = exports.canonFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var canonFontTracking = exports.canonFontTracking = 'CircularSpUIm40-Bold';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloCanonFontSize = exports.celloCanonFontSize = '18px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloCanonA11YFontSizeMin = exports.celloCanonA11YFontSizeMin = '15px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloCanonA11YFontSizeMax = exports.celloCanonA11YFontSizeMax = '24px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloCanonA11YFontSizeAxMax = exports.celloCanonA11YFontSizeAxMax = '54px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloCanonLineHeight = exports.celloCanonLineHeight = '24px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloCanonA11YLineHeightMax = exports.celloCanonA11YLineHeightMax = '30px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloCanonA11YLineHeightAxMax = exports.celloCanonA11YLineHeightAxMax = '60px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloCanonWeight = exports.celloCanonWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloCanonFont = exports.celloCanonFont = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloFontSize = exports.celloFontSize = '18px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloA11YFontSizeMin = exports.celloA11YFontSizeMin = '15px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloA11YFontSizeMax = exports.celloA11YFontSizeMax = '24px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloA11YFontSizeAxMax = exports.celloA11YFontSizeAxMax = '54px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloLineHeight = exports.celloLineHeight = '24px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloA11YLineHeightMax = exports.celloA11YLineHeightMax = '30px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloA11YLineHeightAxMax = exports.celloA11YLineHeightAxMax = '60px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloWeight = exports.celloWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
var celloFont = exports.celloFont = 'Circular';
var color = exports.color = {
          aquamarine: aquamarine,
aubergine: aubergine,
azure: azure,
bole: bole,
brightRed: brightRed,
chocolate: chocolate,
citric: citric,
electricSeafoam: electricSeafoam,
factoryYellow: factoryYellow,
forest: forest,
fuchsia: fuchsia,
gold: gold,
kleinBlue: kleinBlue,
lavender: lavender,
maroon: maroon,
midnight: midnight,
neonGreen: neonGreen,
orange: orange,
pink: pink,
plum: plum,
powderGreen: powderGreen,
royalBlue: royalBlue,
salmon: salmon,
spearmint: spearmint,
storm: storm,
sunflower: sunflower,
tan: tan,
tangerine: tangerine,
violet: violet,
success: success,
announcement: announcement,
info: info,
warning: warning,
failure: failure,
gray7: gray7,
gray10: gray10,
gray15: gray15,
gray20: gray20,
gray30: gray30,
gray50: gray50,
gray70: gray70,
gray80: gray80,
gray85: gray85,
gray90: gray90,
gray95: gray95,
gray25: gray25,
opacityBlack0: opacityBlack0,
opacityBlack10: opacityBlack10,
opacityBlack30: opacityBlack30,
opacityBlack50: opacityBlack50,
opacityBlack60: opacityBlack60,
opacityBlack70: opacityBlack70,
opacityBlack90: opacityBlack90,
opacityWhite0: opacityWhite0,
opacityWhite10: opacityWhite10,
opacityWhite30: opacityWhite30,
opacityWhite50: opacityWhite50,
opacityWhite60: opacityWhite60,
opacityWhite70: opacityWhite70,
opacityWhite90: opacityWhite90,
black0: black0,
black10: black10,
black30: black30,
black50: black50,
black60: black60,
black70: black70,
black90: black90,
white0: white0,
white10: white10,
white30: white30,
white50: white50,
white60: white60,
white70: white70,
white90: white90,
black20: black20,
black40: black40,
white5: white5,
white20: white20,
white40: white40,
green: green,
greenLight: greenLight,
greenFocus: greenFocus,
greenDark: greenDark,
black: black,
white: white,
red: red,
redLight: redLight,
redDark: redDark,
blue: blue,
blueLight: blueLight,
blueFacebook: blueFacebook,
blueDark: blueDark,
orangeLight: orangeLight,
solidBlack0: solidBlack0,
solidWhite200: solidWhite200,
spotifyBlack7: spotifyBlack7,
midnight35: midnight35,
aubergine46: aubergine46,
maroon55: maroon55,
royalBlue55: royalBlue55,
kleinBlue61: kleinBlue61,
forest75: forest75,
chocolate75: chocolate75,
violet84: violet84,
brightRed100: brightRed100,
spearmint114: spearmint114,
fuchsia115: fuchsia115,
tangerine120: tangerine120,
bole123: bole123,
salmon135: salmon135,
lavender135: lavender135,
azure135: azure135,
pumpkin135: pumpkin135,
tan135: tan135,
storm155: storm155,
gold155: gold155,
spotifyGreen157: spotifyGreen157,
sunflower172: sunflower172,
rose180: rose180,
aquamarine180: aquamarine180,
factoryYellow184: factoryYellow184,
powderGreen185: powderGreen185,
citric186: citric186,
neonGreen176: neonGreen176,
electricSeafoam167: electricSeafoam167,
redOrange25: redOrange25,
redOrange55: redOrange55,
redOrange75: redOrange75,
redOrange100: redOrange100,
redOrange120: redOrange120,
redOrange135: redOrange135,
redOrange155: redOrange155,
redOrange180: redOrange180,
brown25: brown25,
brown55: brown55,
brown75: brown75,
brown100: brown100,
brown123: brown123,
brown135: brown135,
brown155: brown155,
brown180: brown180,
brownDesat25: brownDesat25,
brownDesat55: brownDesat55,
brownDesat75: brownDesat75,
brownDesat100: brownDesat100,
brownDesat135: brownDesat135,
brownDesat155: brownDesat155,
brownDesat180: brownDesat180,
orange25: orange25,
orange55: orange55,
orange75: orange75,
orange100: orange100,
orange135: orange135,
orange155: orange155,
orange180: orange180,
brownYellow25: brownYellow25,
brownYellow55: brownYellow55,
brownYellow75: brownYellow75,
brownYellow100: brownYellow100,
brownYellow135: brownYellow135,
brownYellow155: brownYellow155,
brownYellow172: brownYellow172,
brownYellow180: brownYellow180,
brownYellowDesat25: brownYellowDesat25,
brownYellowDesat55: brownYellowDesat55,
brownYellowDesat75: brownYellowDesat75,
brownYellowDesat100: brownYellowDesat100,
brownYellowDesat135: brownYellowDesat135,
brownYellowDesat155: brownYellowDesat155,
brownYellowDesat180: brownYellowDesat180,
yellow25: yellow25,
yellow55: yellow55,
yellow75: yellow75,
yellow100: yellow100,
yellow135: yellow135,
yellow155: yellow155,
yellow184: yellow184,
yellowGreen25: yellowGreen25,
yellowGreen55: yellowGreen55,
yellowGreen75: yellowGreen75,
yellowGreen100: yellowGreen100,
yellowGreen135: yellowGreen135,
yellowGreen155: yellowGreen155,
yellowGreen186: yellowGreen186,
yellowGreenDesat25: yellowGreenDesat25,
yellowGreenDesat55: yellowGreenDesat55,
yellowGreenDesat75: yellowGreenDesat75,
yellowGreenDesat100: yellowGreenDesat100,
yellowGreenDesat135: yellowGreenDesat135,
yellowGreenDesat155: yellowGreenDesat155,
yellowGreenDesat180: yellowGreenDesat180,
green25: green25,
green55: green55,
green75: green75,
green100: green100,
green135: green135,
green157: green157,
green180: green180,
greenDesat25: greenDesat25,
greenDesat55: greenDesat55,
greenDesat75: greenDesat75,
greenDesat100: greenDesat100,
greenDesat135: greenDesat135,
greenDesat155: greenDesat155,
greenDesat185: greenDesat185,
greenBlue25: greenBlue25,
greenBlue55: greenBlue55,
greenBlue75: greenBlue75,
greenBlue100: greenBlue100,
greenBlue135: greenBlue135,
greenBlue155: greenBlue155,
greenBlue180: greenBlue180,
greenBlueDesat25: greenBlueDesat25,
greenBlueDesat55: greenBlueDesat55,
greenBlueDesat75: greenBlueDesat75,
greenBlueDesat100: greenBlueDesat100,
greenBlueDesat114: greenBlueDesat114,
greenBlueDesat135: greenBlueDesat135,
greenBlueDesat155: greenBlueDesat155,
greenBlueDesat180: greenBlueDesat180,
blue25: blue25,
blue55: blue55,
blue75: blue75,
blue100: blue100,
blue135: blue135,
blue155: blue155,
blue180: blue180,
blueDesat25: blueDesat25,
blueDesat55: blueDesat55,
blueDesat75: blueDesat75,
blueDesat100: blueDesat100,
blueDesat135: blueDesat135,
blueDesat155: blueDesat155,
blueDesat180: blueDesat180,
blueViolet25: blueViolet25,
blueViolet55: blueViolet55,
blueViolet61: blueViolet61,
blueViolet75: blueViolet75,
blueViolet100: blueViolet100,
blueViolet135: blueViolet135,
blueViolet155: blueViolet155,
blueViolet180: blueViolet180,
blueVioletDesat25: blueVioletDesat25,
blueVioletDesat35: blueVioletDesat35,
blueVioletDesat55: blueVioletDesat55,
blueVioletDesat75: blueVioletDesat75,
blueVioletDesat100: blueVioletDesat100,
blueVioletDesat135: blueVioletDesat135,
blueVioletDesat155: blueVioletDesat155,
blueVioletDesat180: blueVioletDesat180,
violet25: violet25,
violet55: violet55,
violet75: violet75,
violet100: violet100,
violet135: violet135,
violet155: violet155,
violet180: violet180,
violetDesat25: violetDesat25,
violetDesat46: violetDesat46,
violetDesat75: violetDesat75,
violetDesat100: violetDesat100,
violetDesat135: violetDesat135,
violetDesat155: violetDesat155,
violetDesat180: violetDesat180,
violetPink25: violetPink25,
violetPink55: violetPink55,
violetPink75: violetPink75,
violetPink84: violetPink84,
violetPink100: violetPink100,
violetPink135: violetPink135,
violetPink155: violetPink155,
violetPink180: violetPink180,
violetPinkDesat25: violetPinkDesat25,
violetPinkDesat55: violetPinkDesat55,
violetPinkDesat67: violetPinkDesat67,
violetPinkDesat100: violetPinkDesat100,
violetPinkDesat135: violetPinkDesat135,
violetPinkDesat155: violetPinkDesat155,
violetPinkDesat180: violetPinkDesat180,
pink25: pink25,
pink55: pink55,
pink75: pink75,
pink100: pink100,
pink115: pink115,
pink135: pink135,
pink155: pink155,
pink180: pink180,
pinkDesat25: pinkDesat25,
pinkDesat55: pinkDesat55,
pinkDesat75: pinkDesat75,
pinkDesat100: pinkDesat100,
pinkDesat135: pinkDesat135,
pinkDesat155: pinkDesat155,
pinkDesat180: pinkDesat180,
red25: red25,
red55: red55,
red75: red75,
red100: red100,
red135: red135,
red155: red155,
red180: red180,
redDesat25: redDesat25,
redDesat55: redDesat55,
redDesat75: redDesat75,
redDesat100: redDesat100,
redDesat135: redDesat135,
redDesat155: redDesat155,
redDesat180: redDesat180,
fluorescentRed109: fluorescentRed109,
fluorescentOrange144: fluorescentOrange144,
fluorescentYellow194: fluorescentYellow194,
fluorescentGreen176: fluorescentGreen176,
fluorescentGreenBlue167: fluorescentGreenBlue167,
fluorescentCyan185: fluorescentCyan185,
fluorescentBlueViolet69: fluorescentBlueViolet69,
fluorescentViolet111: fluorescentViolet111,
fluorescentPink119: fluorescentPink119,
        };
var cdn = exports.cdn = {
          circularSpotifyUiArabicBlackOtf: circularSpotifyUiArabicBlackOtf,
circularSpotifyUiArabicBlackWoff: circularSpotifyUiArabicBlackWoff,
circularSpotifyUiArabicBlackWoff2: circularSpotifyUiArabicBlackWoff2,
circularSpotifyUiArabicBoldOtf: circularSpotifyUiArabicBoldOtf,
circularSpotifyUiArabicBoldWoff: circularSpotifyUiArabicBoldWoff,
circularSpotifyUiArabicBoldWoff2: circularSpotifyUiArabicBoldWoff2,
circularSpotifyUiArabicBookOtf: circularSpotifyUiArabicBookOtf,
circularSpotifyUiArabicBookWoff: circularSpotifyUiArabicBookWoff,
circularSpotifyUiArabicBookWoff2: circularSpotifyUiArabicBookWoff2,
circularSpotifyUiArabicLightOtf: circularSpotifyUiArabicLightOtf,
circularSpotifyUiArabicLightWoff: circularSpotifyUiArabicLightWoff,
circularSpotifyUiArabicLightWoff2: circularSpotifyUiArabicLightWoff2,
circularSpotifyUiArabicMediumOtf: circularSpotifyUiArabicMediumOtf,
circularSpotifyUiArabicMediumWoff: circularSpotifyUiArabicMediumWoff,
circularSpotifyUiArabicMediumWoff2: circularSpotifyUiArabicMediumWoff2,
circularSpotifyUiCyrillicBlackOtf: circularSpotifyUiCyrillicBlackOtf,
circularSpotifyUiCyrillicBlackWoff: circularSpotifyUiCyrillicBlackWoff,
circularSpotifyUiCyrillicBlackWoff2: circularSpotifyUiCyrillicBlackWoff2,
circularSpotifyUiCyrillicBoldOtf: circularSpotifyUiCyrillicBoldOtf,
circularSpotifyUiCyrillicBoldWoff: circularSpotifyUiCyrillicBoldWoff,
circularSpotifyUiCyrillicBoldWoff2: circularSpotifyUiCyrillicBoldWoff2,
circularSpotifyUiCyrillicBookOtf: circularSpotifyUiCyrillicBookOtf,
circularSpotifyUiCyrillicBookWoff: circularSpotifyUiCyrillicBookWoff,
circularSpotifyUiCyrillicBookWoff2: circularSpotifyUiCyrillicBookWoff2,
circularSpotifyUiCyrillicLightOtf: circularSpotifyUiCyrillicLightOtf,
circularSpotifyUiCyrillicLightWoff: circularSpotifyUiCyrillicLightWoff,
circularSpotifyUiCyrillicLightWoff2: circularSpotifyUiCyrillicLightWoff2,
circularSpotifyUiCyrillicMediumOtf: circularSpotifyUiCyrillicMediumOtf,
circularSpotifyUiCyrillicMediumWoff: circularSpotifyUiCyrillicMediumWoff,
circularSpotifyUiCyrillicMediumWoff2: circularSpotifyUiCyrillicMediumWoff2,
circularSpotifyUiHebrewBlackOtf: circularSpotifyUiHebrewBlackOtf,
circularSpotifyUiHebrewBlackWoff: circularSpotifyUiHebrewBlackWoff,
circularSpotifyUiHebrewBlackWoff2: circularSpotifyUiHebrewBlackWoff2,
circularSpotifyUiHebrewBoldOtf: circularSpotifyUiHebrewBoldOtf,
circularSpotifyUiHebrewBoldWoff: circularSpotifyUiHebrewBoldWoff,
circularSpotifyUiHebrewBoldWoff2: circularSpotifyUiHebrewBoldWoff2,
circularSpotifyUiHebrewBookOtf: circularSpotifyUiHebrewBookOtf,
circularSpotifyUiHebrewBookWoff: circularSpotifyUiHebrewBookWoff,
circularSpotifyUiHebrewBookWoff2: circularSpotifyUiHebrewBookWoff2,
circularSpotifyUiHebrewLightOtf: circularSpotifyUiHebrewLightOtf,
circularSpotifyUiHebrewLightWoff: circularSpotifyUiHebrewLightWoff,
circularSpotifyUiHebrewLightWoff2: circularSpotifyUiHebrewLightWoff2,
circularSpotifyUiHebrewMediumOtf: circularSpotifyUiHebrewMediumOtf,
circularSpotifyUiHebrewMediumWoff: circularSpotifyUiHebrewMediumWoff,
circularSpotifyUiHebrewMediumWoff2: circularSpotifyUiHebrewMediumWoff2,
circularSpotifyUiLatinBlackOtf: circularSpotifyUiLatinBlackOtf,
circularSpotifyUiLatinBlackWoff: circularSpotifyUiLatinBlackWoff,
circularSpotifyUiLatinBlackWoff2: circularSpotifyUiLatinBlackWoff2,
circularSpotifyUiLatinBoldOtf: circularSpotifyUiLatinBoldOtf,
circularSpotifyUiLatinBoldWoff: circularSpotifyUiLatinBoldWoff,
circularSpotifyUiLatinBoldWoff2: circularSpotifyUiLatinBoldWoff2,
circularSpotifyUiLatinBookOtf: circularSpotifyUiLatinBookOtf,
circularSpotifyUiLatinBookWoff: circularSpotifyUiLatinBookWoff,
circularSpotifyUiLatinBookWoff2: circularSpotifyUiLatinBookWoff2,
circularSpotifyUiLatinLightOtf: circularSpotifyUiLatinLightOtf,
circularSpotifyUiLatinLightWoff: circularSpotifyUiLatinLightWoff,
circularSpotifyUiLatinLightWoff2: circularSpotifyUiLatinLightWoff2,
circularSpotifyUiLatinMediumOtf: circularSpotifyUiLatinMediumOtf,
circularSpotifyUiLatinMediumWoff: circularSpotifyUiLatinMediumWoff,
circularSpotifyUiLatinMediumWoff2: circularSpotifyUiLatinMediumWoff2,
circularSpotifyUiLatinOs2V3BlackOtf: circularSpotifyUiLatinOs2V3BlackOtf,
circularSpotifyUiLatinOs2V3BlackWoff: circularSpotifyUiLatinOs2V3BlackWoff,
circularSpotifyUiLatinOs2V3BlackWoff2: circularSpotifyUiLatinOs2V3BlackWoff2,
circularSpotifyUiLatinOs2V3BoldOtf: circularSpotifyUiLatinOs2V3BoldOtf,
circularSpotifyUiLatinOs2V3BoldWoff: circularSpotifyUiLatinOs2V3BoldWoff,
circularSpotifyUiLatinOs2V3BoldWoff2: circularSpotifyUiLatinOs2V3BoldWoff2,
circularSpotifyUiLatinOs2V3BookOtf: circularSpotifyUiLatinOs2V3BookOtf,
circularSpotifyUiLatinOs2V3BookWoff: circularSpotifyUiLatinOs2V3BookWoff,
circularSpotifyUiLatinOs2V3BookWoff2: circularSpotifyUiLatinOs2V3BookWoff2,
circularSpotifyUiLatinOs2V3LightOtf: circularSpotifyUiLatinOs2V3LightOtf,
circularSpotifyUiLatinOs2V3LightWoff: circularSpotifyUiLatinOs2V3LightWoff,
circularSpotifyUiLatinOs2V3LightWoff2: circularSpotifyUiLatinOs2V3LightWoff2,
circularSpotifyUiLatinOs2V3MediumOtf: circularSpotifyUiLatinOs2V3MediumOtf,
circularSpotifyUiLatinOs2V3MediumWoff: circularSpotifyUiLatinOs2V3MediumWoff,
circularSpotifyUiLatinOs2V3MediumWoff2: circularSpotifyUiLatinOs2V3MediumWoff2,
circularMonoLatinBookOtf: circularMonoLatinBookOtf,
circularMonoLatinBookWoff: circularMonoLatinBookWoff,
sieulguilSpotifyHangulBlackOtf: sieulguilSpotifyHangulBlackOtf,
sieulguilSpotifyHangulBlackWoff: sieulguilSpotifyHangulBlackWoff,
sieulguilSpotifyHangulBlackWoff2: sieulguilSpotifyHangulBlackWoff2,
sieulguilSpotifyHangulBoldOtf: sieulguilSpotifyHangulBoldOtf,
sieulguilSpotifyHangulBoldWoff: sieulguilSpotifyHangulBoldWoff,
sieulguilSpotifyHangulBoldWoff2: sieulguilSpotifyHangulBoldWoff2,
sieulguilSpotifyHangulLightOtf: sieulguilSpotifyHangulLightOtf,
sieulguilSpotifyHangulLightWoff: sieulguilSpotifyHangulLightWoff,
sieulguilSpotifyHangulLightWoff2: sieulguilSpotifyHangulLightWoff2,
sieulguilSpotifyHangulMediumOtf: sieulguilSpotifyHangulMediumOtf,
sieulguilSpotifyHangulMediumWoff: sieulguilSpotifyHangulMediumWoff,
sieulguilSpotifyHangulMediumWoff2: sieulguilSpotifyHangulMediumWoff2,
sieulguilSpotifyLatinHangulBlackOtf: sieulguilSpotifyLatinHangulBlackOtf,
sieulguilSpotifyLatinHangulBlackWoff: sieulguilSpotifyLatinHangulBlackWoff,
sieulguilSpotifyLatinHangulBlackWoff2: sieulguilSpotifyLatinHangulBlackWoff2,
sieulguilSpotifyLatinHangulBoldOtf: sieulguilSpotifyLatinHangulBoldOtf,
sieulguilSpotifyLatinHangulBoldWoff: sieulguilSpotifyLatinHangulBoldWoff,
sieulguilSpotifyLatinHangulBoldWoff2: sieulguilSpotifyLatinHangulBoldWoff2,
sieulguilSpotifyLatinHangulLightOtf: sieulguilSpotifyLatinHangulLightOtf,
sieulguilSpotifyLatinHangulLightWoff: sieulguilSpotifyLatinHangulLightWoff,
sieulguilSpotifyLatinHangulLightWoff2: sieulguilSpotifyLatinHangulLightWoff2,
sieulguilSpotifyLatinHangulMediumOtf: sieulguilSpotifyLatinHangulMediumOtf,
sieulguilSpotifyLatinHangulMediumWoff: sieulguilSpotifyLatinHangulMediumWoff,
sieulguilSpotifyLatinHangulMediumWoff2: sieulguilSpotifyLatinHangulMediumWoff2,
        };
var opacity = exports.opacity = {
          opacity0: opacity0,
opacity10: opacity10,
opacity30: opacity30,
opacity50: opacity50,
opacity70: opacity70,
opacity90: opacity90,
        };
var spacer = exports.spacer = {
          spacer4: spacer4,
spacer8: spacer8,
spacer12: spacer12,
spacer16: spacer16,
spacer20: spacer20,
spacer24: spacer24,
spacer32: spacer32,
spacer40: spacer40,
spacer48: spacer48,
spacer56: spacer56,
spacer64: spacer64,
spacer72: spacer72,
spacer80: spacer80,
        };
var type = exports.type = {
          balladFontSize: balladFontSize,
balladA11YFontSizeMin: balladA11YFontSizeMin,
balladA11YFontSizeMax: balladA11YFontSizeMax,
balladA11YFontSizeAxMax: balladA11YFontSizeAxMax,
balladLineHeight: balladLineHeight,
balladA11YLineHeightMax: balladA11YLineHeightMax,
balladA11YLineHeightAxMax: balladA11YLineHeightAxMax,
balladWeight: balladWeight,
balladFont: balladFont,
balladBoldFontSize: balladBoldFontSize,
balladBoldA11YFontSizeMin: balladBoldA11YFontSizeMin,
balladBoldA11YFontSizeMax: balladBoldA11YFontSizeMax,
balladBoldA11YFontSizeAxMax: balladBoldA11YFontSizeAxMax,
balladBoldLineHeight: balladBoldLineHeight,
balladBoldA11YLineHeightMax: balladBoldA11YLineHeightMax,
balladBoldA11YLineHeightAxMax: balladBoldA11YLineHeightAxMax,
balladBoldWeight: balladBoldWeight,
balladBoldFont: balladBoldFont,
violaFontSize: violaFontSize,
violaA11YFontSizeMin: violaA11YFontSizeMin,
violaA11YFontSizeMax: violaA11YFontSizeMax,
violaA11YFontSizeAxMax: violaA11YFontSizeAxMax,
violaLineHeight: violaLineHeight,
violaA11YLineHeightMax: violaA11YLineHeightMax,
violaA11YLineHeightAxMax: violaA11YLineHeightAxMax,
violaWeight: violaWeight,
violaFont: violaFont,
violaBoldFontSize: violaBoldFontSize,
violaBoldA11YFontSizeMin: violaBoldA11YFontSizeMin,
violaBoldA11YFontSizeMax: violaBoldA11YFontSizeMax,
violaBoldA11YFontSizeAxMax: violaBoldA11YFontSizeAxMax,
violaBoldLineHeight: violaBoldLineHeight,
violaBoldA11YLineHeightMax: violaBoldA11YLineHeightMax,
violaBoldA11YLineHeightAxMax: violaBoldA11YLineHeightAxMax,
violaBoldWeight: violaBoldWeight,
violaBoldFont: violaBoldFont,
mestoFontSize: mestoFontSize,
mestoA11YFontSizeMin: mestoA11YFontSizeMin,
mestoA11YFontSizeMax: mestoA11YFontSizeMax,
mestoA11YFontSizeAxMax: mestoA11YFontSizeAxMax,
mestoLineHeight: mestoLineHeight,
mestoA11YLineHeightMax: mestoA11YLineHeightMax,
mestoA11YLineHeightAxMax: mestoA11YLineHeightAxMax,
mestoWeight: mestoWeight,
mestoFont: mestoFont,
mestoBoldFontSize: mestoBoldFontSize,
mestoBoldA11YFontSizeMin: mestoBoldA11YFontSizeMin,
mestoBoldA11YFontSizeMax: mestoBoldA11YFontSizeMax,
mestoBoldA11YFontSizeAxMax: mestoBoldA11YFontSizeAxMax,
mestoBoldLineHeight: mestoBoldLineHeight,
mestoBoldA11YLineHeightMax: mestoBoldA11YLineHeightMax,
mestoBoldA11YLineHeightAxMax: mestoBoldA11YLineHeightAxMax,
mestoBoldWeight: mestoBoldWeight,
mestoBoldFont: mestoBoldFont,
bassFontSize: bassFontSize,
bassA11YFontSizeMin: bassA11YFontSizeMin,
bassA11YFontSizeMax: bassA11YFontSizeMax,
bassA11YFontSizeAxMax: bassA11YFontSizeAxMax,
bassLineHeight: bassLineHeight,
bassA11YLineHeightMax: bassA11YLineHeightMax,
bassA11YLineHeightAxMax: bassA11YLineHeightAxMax,
bassWeight: bassWeight,
bassTracking: bassTracking,
bassFont: bassFont,
bassFontTracking: bassFontTracking,
bassMinimumScaleFactorMin: bassMinimumScaleFactorMin,
bassMinimumScaleFactor: bassMinimumScaleFactor,
bassMinimumScaleFactorMax: bassMinimumScaleFactorMax,
bassMinimumScaleFactorAxMax: bassMinimumScaleFactorAxMax,
forteFontSize: forteFontSize,
forteA11YFontSizeMin: forteA11YFontSizeMin,
forteA11YFontSizeMax: forteA11YFontSizeMax,
forteA11YFontSizeAxMax: forteA11YFontSizeAxMax,
forteLineHeight: forteLineHeight,
forteA11YLineHeightMax: forteA11YLineHeightMax,
forteA11YLineHeightAxMax: forteA11YLineHeightAxMax,
forteWeight: forteWeight,
forteTracking: forteTracking,
forteFont: forteFont,
forteFontTracking: forteFontTracking,
forteMinimumScaleFactorMin: forteMinimumScaleFactorMin,
forteMinimumScaleFactor: forteMinimumScaleFactor,
forteMinimumScaleFactorMax: forteMinimumScaleFactorMax,
forteMinimumScaleFactorAxMax: forteMinimumScaleFactorAxMax,
brioFontSize: brioFontSize,
brioA11YFontSizeMin: brioA11YFontSizeMin,
brioA11YFontSizeMax: brioA11YFontSizeMax,
brioA11YFontSizeAxMax: brioA11YFontSizeAxMax,
brioLineHeight: brioLineHeight,
brioA11YLineHeightMax: brioA11YLineHeightMax,
brioA11YLineHeightAxMax: brioA11YLineHeightAxMax,
brioWeight: brioWeight,
brioTracking: brioTracking,
brioFont: brioFont,
brioFontTracking: brioFontTracking,
brioMinimumScaleFactorMin: brioMinimumScaleFactorMin,
brioMinimumScaleFactor: brioMinimumScaleFactor,
brioMinimumScaleFactorMax: brioMinimumScaleFactorMax,
brioMinimumScaleFactorAxMax: brioMinimumScaleFactorAxMax,
finaleFontSize: finaleFontSize,
finaleA11YFontSizeMin: finaleA11YFontSizeMin,
finaleA11YFontSizeMax: finaleA11YFontSizeMax,
finaleA11YFontSizeAxMax: finaleA11YFontSizeAxMax,
finaleLineHeight: finaleLineHeight,
finaleA11YLineHeightMax: finaleA11YLineHeightMax,
finaleA11YLineHeightAxMax: finaleA11YLineHeightAxMax,
finaleWeight: finaleWeight,
finaleFont: finaleFont,
finaleBoldFontSize: finaleBoldFontSize,
finaleBoldA11YFontSizeMin: finaleBoldA11YFontSizeMin,
finaleBoldA11YFontSizeMax: finaleBoldA11YFontSizeMax,
finaleBoldA11YFontSizeAxMax: finaleBoldA11YFontSizeAxMax,
finaleBoldLineHeight: finaleBoldLineHeight,
finaleBoldA11YLineHeightMax: finaleBoldA11YLineHeightMax,
finaleBoldA11YLineHeightAxMax: finaleBoldA11YLineHeightAxMax,
finaleBoldWeight: finaleBoldWeight,
finaleBoldFont: finaleBoldFont,
minuetFontSize: minuetFontSize,
minuetA11YFontSizeMin: minuetA11YFontSizeMin,
minuetA11YFontSizeMax: minuetA11YFontSizeMax,
minuetA11YFontSizeAxMax: minuetA11YFontSizeAxMax,
minuetLineHeight: minuetLineHeight,
minuetA11YLineHeightMax: minuetA11YLineHeightMax,
minuetA11YLineHeightAxMax: minuetA11YLineHeightAxMax,
minuetWeight: minuetWeight,
minuetTracking: minuetTracking,
minuetUppercase: minuetUppercase,
minuetFont: minuetFont,
minuetFontTracking: minuetFontTracking,
minuetBoldFontSize: minuetBoldFontSize,
minuetBoldA11YFontSizeMin: minuetBoldA11YFontSizeMin,
minuetBoldA11YFontSizeMax: minuetBoldA11YFontSizeMax,
minuetBoldA11YFontSizeAxMax: minuetBoldA11YFontSizeAxMax,
minuetBoldLineHeight: minuetBoldLineHeight,
minuetBoldA11YLineHeightMax: minuetBoldA11YLineHeightMax,
minuetBoldA11YLineHeightAxMax: minuetBoldA11YLineHeightAxMax,
minuetBoldWeight: minuetBoldWeight,
minuetBoldTracking: minuetBoldTracking,
minuetBoldUppercase: minuetBoldUppercase,
minuetBoldFont: minuetBoldFont,
minuetBoldFontTracking: minuetBoldFontTracking,
metronomeFontSize: metronomeFontSize,
metronomeA11YFontSizeMin: metronomeA11YFontSizeMin,
metronomeA11YFontSizeMax: metronomeA11YFontSizeMax,
metronomeA11YFontSizeAxMax: metronomeA11YFontSizeAxMax,
metronomeLineHeight: metronomeLineHeight,
metronomeA11YLineHeightMax: metronomeA11YLineHeightMax,
metronomeA11YLineHeightAxMax: metronomeA11YLineHeightAxMax,
metronomeWeight: metronomeWeight,
metronomeTracking: metronomeTracking,
metronomeA11YTrackingMin: metronomeA11YTrackingMin,
metronomeA11YTrackingMax: metronomeA11YTrackingMax,
metronomeA11YTrackingAxMax: metronomeA11YTrackingAxMax,
metronomeUppercase: metronomeUppercase,
metronomeFont: metronomeFont,
metronomeFontTracking: metronomeFontTracking,
altoBrioFontSize: altoBrioFontSize,
altoBrioA11YFontSizeMin: altoBrioA11YFontSizeMin,
altoBrioA11YFontSizeMax: altoBrioA11YFontSizeMax,
altoBrioA11YFontSizeAxMax: altoBrioA11YFontSizeAxMax,
altoBrioLineHeight: altoBrioLineHeight,
altoBrioA11YLineHeightMax: altoBrioA11YLineHeightMax,
altoBrioA11YLineHeightAxMax: altoBrioA11YLineHeightAxMax,
altoBrioWeight: altoBrioWeight,
altoBrioTracking: altoBrioTracking,
altoBrioFont: altoBrioFont,
altoBrioFontTracking: altoBrioFontTracking,
altoFontSize: altoFontSize,
altoA11YFontSizeMin: altoA11YFontSizeMin,
altoA11YFontSizeMax: altoA11YFontSizeMax,
altoA11YFontSizeAxMax: altoA11YFontSizeAxMax,
altoLineHeight: altoLineHeight,
altoA11YLineHeightMax: altoA11YLineHeightMax,
altoA11YLineHeightAxMax: altoA11YLineHeightAxMax,
altoWeight: altoWeight,
altoTracking: altoTracking,
altoFont: altoFont,
altoFontTracking: altoFontTracking,
canonFontSize: canonFontSize,
canonA11YFontSizeMin: canonA11YFontSizeMin,
canonA11YFontSizeMax: canonA11YFontSizeMax,
canonA11YFontSizeAxMax: canonA11YFontSizeAxMax,
canonLineHeight: canonLineHeight,
canonA11YLineHeightMax: canonA11YLineHeightMax,
canonA11YLineHeightAxMax: canonA11YLineHeightAxMax,
canonWeight: canonWeight,
canonTracking: canonTracking,
canonFont: canonFont,
canonFontTracking: canonFontTracking,
celloCanonFontSize: celloCanonFontSize,
celloCanonA11YFontSizeMin: celloCanonA11YFontSizeMin,
celloCanonA11YFontSizeMax: celloCanonA11YFontSizeMax,
celloCanonA11YFontSizeAxMax: celloCanonA11YFontSizeAxMax,
celloCanonLineHeight: celloCanonLineHeight,
celloCanonA11YLineHeightMax: celloCanonA11YLineHeightMax,
celloCanonA11YLineHeightAxMax: celloCanonA11YLineHeightAxMax,
celloCanonWeight: celloCanonWeight,
celloCanonFont: celloCanonFont,
celloFontSize: celloFontSize,
celloA11YFontSizeMin: celloA11YFontSizeMin,
celloA11YFontSizeMax: celloA11YFontSizeMax,
celloA11YFontSizeAxMax: celloA11YFontSizeAxMax,
celloLineHeight: celloLineHeight,
celloA11YLineHeightMax: celloA11YLineHeightMax,
celloA11YLineHeightAxMax: celloA11YLineHeightAxMax,
celloWeight: celloWeight,
celloFont: celloFont,
        };
var ballad = exports.ballad = {
  fontSize: balladFontSize,
  lineHeight: balladLineHeight,
  fontWeight: balladWeight,
};
var balladBold = exports.balladBold = {
  fontSize: balladBoldFontSize,
  lineHeight: balladBoldLineHeight,
  fontWeight: balladBoldWeight,
};
var viola = exports.viola = {
  fontSize: violaFontSize,
  lineHeight: violaLineHeight,
  fontWeight: violaWeight,
};
var violaBold = exports.violaBold = {
  fontSize: violaBoldFontSize,
  lineHeight: violaBoldLineHeight,
  fontWeight: violaBoldWeight,
};
var mesto = exports.mesto = {
  fontSize: mestoFontSize,
  lineHeight: mestoLineHeight,
  fontWeight: mestoWeight,
};
var mestoBold = exports.mestoBold = {
  fontSize: mestoBoldFontSize,
  lineHeight: mestoBoldLineHeight,
  fontWeight: mestoBoldWeight,
};
var bass = exports.bass = {
  fontSize: bassFontSize,
  lineHeight: bassLineHeight,
  fontWeight: bassWeight,
  letterSpacing: bassTracking,
};
var forte = exports.forte = {
  fontSize: forteFontSize,
  lineHeight: forteLineHeight,
  fontWeight: forteWeight,
  letterSpacing: forteTracking,
};
var brio = exports.brio = {
  fontSize: brioFontSize,
  lineHeight: brioLineHeight,
  fontWeight: brioWeight,
  letterSpacing: brioTracking,
};
var finale = exports.finale = {
  fontSize: finaleFontSize,
  lineHeight: finaleLineHeight,
  fontWeight: finaleWeight,
};
var finaleBold = exports.finaleBold = {
  fontSize: finaleBoldFontSize,
  lineHeight: finaleBoldLineHeight,
  fontWeight: finaleBoldWeight,
};
var minuet = exports.minuet = {
  fontSize: minuetFontSize,
  lineHeight: minuetLineHeight,
  fontWeight: minuetWeight,
  letterSpacing: minuetTracking,
  textTransform: minuetUppercase,
};
var minuetBold = exports.minuetBold = {
  fontSize: minuetBoldFontSize,
  lineHeight: minuetBoldLineHeight,
  fontWeight: minuetBoldWeight,
  letterSpacing: minuetBoldTracking,
  textTransform: minuetBoldUppercase,
};
var metronome = exports.metronome = {
  fontSize: metronomeFontSize,
  lineHeight: metronomeLineHeight,
  fontWeight: metronomeWeight,
  letterSpacing: metronomeTracking,
  textTransform: metronomeUppercase,
};
var altoBrio = exports.altoBrio = {
  fontSize: altoBrioFontSize,
  lineHeight: altoBrioLineHeight,
  fontWeight: altoBrioWeight,
  letterSpacing: altoBrioTracking,
};
var alto = exports.alto = {
  fontSize: altoFontSize,
  lineHeight: altoLineHeight,
  fontWeight: altoWeight,
  letterSpacing: altoTracking,
};
var canon = exports.canon = {
  fontSize: canonFontSize,
  lineHeight: canonLineHeight,
  fontWeight: canonWeight,
  letterSpacing: canonTracking,
};
var celloCanon = exports.celloCanon = {
  fontSize: celloCanonFontSize,
  lineHeight: celloCanonLineHeight,
  fontWeight: celloCanonWeight,
};
var cello = exports.cello = {
  fontSize: celloFontSize,
  lineHeight: celloLineHeight,
  fontWeight: celloWeight,
};